/**
 * The studio's not-found page (web-client-app D4, task 8.8): any address the
 * site does not have. The server answers it with status 404.
 */
import { NotFound } from '../pieces/not-found';
import { usePageTitle } from '../ui/usePageTitle';

export function NotFoundPage() {
  usePageTitle('Page not found');
  return <NotFound />;
}
